import React, { useState } from 'react';
import clsx from 'clsx';
import MuiSettingsIcon from '@material-ui/icons/Settings';
import './settingsIcon.css';

const SettingsIcon = () => {
    const [mouseLeft, setMouseLeft] = useState(false);

    const handleMouseLeave = () => {
        setMouseLeft(true);
    };

    return (
        <div className="rolling-settings-wrapper">
            <MuiSettingsIcon
                className={clsx("roll", {"roll-out": mouseLeft})}
                onMouseLeave={handleMouseLeave}
            />
        </div>
    );
};

export default SettingsIcon;
